// crm namespace — Sequence editor (admin/crm/pages/CrmSequenceEditor.jsx, admin/crm/email/editor/*):
// trigger picker, step list, merge fields, send test, the system-sequence trigger lock,
// and the trigger/offset closed-set labels (contract.js TRIGGER_KEYS, OFFSET_UNIT_KEYS,
// OFFSET_UNIT_SINGULAR_KEYS, OFFSET_ANCHOR_KEYS, SYSTEM_KEY_NAME_KEYS).
// Flat dotted keys, the same set in fr / en / es (i18n/__tests__/symmetry.test.js).
export default {
  fr: {
    "seq.saveDraft": "Enregistrer le brouillon",
    "seq.activate": "Activer",
    "seq.savedDraft": "Brouillon enregistré",
    "seq.activated": "Séquence activée",
    "seq.namePlaceholder": "Nom de la séquence",
    "seq.triggerLabel": "Déclencheur",
    "seq.triggerLocked": "Le déclencheur d'une séquence prête à l'emploi ne peut pas être modifié.",
    "seq.triggerParamDays": "jours",
    "seq.triggerParamTag": "étiquette",
    "seq.triggerParamN": "numéro de séance",
    "seq.stepTitle": "Étape {n}",
    "seq.stepSummary": "Étape {n} · {offset} · {excerpt}",
    "seq.stepSummaryNoBody": "Étape {n} · {offset} · sans contenu",
    "seq.sendTestSent": "Test envoyé à votre propre adresse",
    "seq.sendTestQueued": "Test enregistré — il partira dès que l'envoi d'e-mails sera configuré",
    "seq.deleteStep": "Supprimer",
    "seq.deleteStepConfirmTitle": "Supprimer cette étape ?",
    "seq.deleteStepConfirmBody": "Cette étape sera retirée de la séquence.",
    "seq.deleteStepConfirm": "Supprimer l'étape",
    "seq.subjectLabel": "Objet",
    "seq.subjectPlaceholder": "Objet de l'e-mail",
    "seq.bodyLabel": "Message",
    "seq.bookAgainButton": "Bouton « Réserver à nouveau »",
    "seq.addStep": "+ Ajouter une étape",
    "seq.unsavedTitle": "Quitter sans enregistrer ?",
    "seq.unsavedBody": "Les modifications apportées à cette séquence n'ont pas été enregistrées.",
    "seq.unsavedLeave": "Quitter",
    "seq.unsavedStay": "Rester",
    "seq.confirmReminder": "Confirmer",
    "seq.rescheduleReminder": "Reporter",
    "seq.joinReminder": "Rejoindre",
    "seq.offsetValueLabel": "Délai",
    "seq.offsetUnitAnchorLabel": "Unité et échéance",
    "seq.system.welcome": "Bienvenue",
    "seq.system.sessionReminders": "Rappels de séance",
    "seq.system.followUp": "Suivi",
    "seq.system.reEngagement": "Réactivation",
    "seq.system.reviewRequest": "Demande d'avis",
    "seq.trigger.newClient": "Nouveau client",
    "seq.trigger.bookingExists": "Réservation existante",
    "seq.trigger.bookingCompleted": "Séance terminée",
    "seq.trigger.purchaseCompleted": "Achat effectué",
    "seq.trigger.noActivity": "Aucune activité depuis {days} jours",
    "seq.trigger.packBalanceHits": "Solde de forfait à {n}",
    "seq.trigger.tagAdded": "Étiquette « {tag} » ajoutée",
    "seq.trigger.nthSessionCompleted": "Séance n° {n} terminée",
    "seq.trigger.reviewMoment": "Moment de la demande d'avis",
    "seq.trigger.reviewMomentAt": "Après {n} séances terminées",
    "seq.trigger.pathwayProgress": "Étape ou niveau de parcours terminé",
    "seq.trigger.pathwayCompleted": "Parcours terminé",
    "seq.trigger.pathwayUnit.step": "une étape",
    "seq.trigger.pathwayUnit.level": "un niveau",
    "seq.triggerPathwayLabel": "Parcours",
    "seq.triggerPathwayAny": "N'importe quel parcours",
    "seq.triggerPathwayUnknown": "Parcours introuvable",
    "seq.triggerPathwayUnitLabel": "Quand l'apprenant termine",
    "seq.triggerPathwayLoadFailed": "La liste des parcours n'a pas pu être chargée.",
    "seq.reviewThresholdHint": "Part quand un client termine {n} séances.",
    "seq.reviewThresholdLink": "Modifier ce nombre dans les réglages",
    "seq.offsetUnit.minutes": "minutes",
    "seq.offsetUnit.hours": "heures",
    "seq.offsetUnit.days": "jours",
    "seq.offsetUnitOne.minutes": "minute",
    "seq.offsetUnitOne.hours": "heure",
    "seq.offsetUnitOne.days": "jour",
    "seq.offsetAnchor.afterTrigger": "après le déclencheur",
    "seq.offsetAnchor.beforeSession": "avant la séance",
  },
  en: {
    "seq.saveDraft": "Save draft",
    "seq.activate": "Activate",
    "seq.savedDraft": "Draft saved",
    "seq.activated": "Sequence activated",
    "seq.namePlaceholder": "Sequence name",
    "seq.triggerLabel": "Trigger",
    "seq.triggerLocked": "A pre-built sequence's trigger cannot be changed.",
    "seq.triggerParamDays": "days",
    "seq.triggerParamTag": "tag",
    "seq.triggerParamN": "session number",
    "seq.stepTitle": "Step {n}",
    "seq.stepSummary": "Step {n} · {offset} · {excerpt}",
    "seq.stepSummaryNoBody": "Step {n} · {offset} · no content yet",
    "seq.sendTestSent": "Test sent to your own address",
    "seq.sendTestQueued": "Test recorded — it will go out once email sending is configured",
    "seq.deleteStep": "Delete",
    "seq.deleteStepConfirmTitle": "Remove this step?",
    "seq.deleteStepConfirmBody": "This step will be removed from the sequence.",
    "seq.deleteStepConfirm": "Remove step",
    "seq.subjectLabel": "Subject",
    "seq.subjectPlaceholder": "Email subject",
    "seq.bodyLabel": "Body",
    "seq.bookAgainButton": "Book again button",
    "seq.addStep": "+ Add step",
    "seq.unsavedTitle": "Leave without saving?",
    "seq.unsavedBody": "Your changes to this sequence have not been saved.",
    "seq.unsavedLeave": "Leave",
    "seq.unsavedStay": "Stay",
    "seq.confirmReminder": "Confirm",
    "seq.rescheduleReminder": "Reschedule",
    "seq.joinReminder": "Join",
    "seq.offsetValueLabel": "Delay",
    "seq.offsetUnitAnchorLabel": "Unit and timing",
    "seq.system.welcome": "Welcome",
    "seq.system.sessionReminders": "Session reminders",
    "seq.system.followUp": "Follow-up",
    "seq.system.reEngagement": "Re-engagement",
    "seq.system.reviewRequest": "Review request",
    "seq.trigger.newClient": "New client",
    "seq.trigger.bookingExists": "Booking exists",
    "seq.trigger.bookingCompleted": "Booking completed",
    "seq.trigger.purchaseCompleted": "Purchase completed",
    "seq.trigger.noActivity": "No activity for {days} days",
    "seq.trigger.packBalanceHits": "Pack balance hits {n}",
    "seq.trigger.tagAdded": "Tag “{tag}” added",
    "seq.trigger.nthSessionCompleted": "Session {n} completed",
    "seq.trigger.reviewMoment": "Review-request moment",
    "seq.trigger.reviewMomentAt": "After {n} completed sessions",
    "seq.trigger.pathwayProgress": "Pathway step/level completed",
    "seq.trigger.pathwayCompleted": "Pathway completed",
    "seq.trigger.pathwayUnit.step": "a step",
    "seq.trigger.pathwayUnit.level": "a level",
    "seq.triggerPathwayLabel": "Pathway",
    "seq.triggerPathwayAny": "Any pathway",
    "seq.triggerPathwayUnknown": "Pathway not found",
    "seq.triggerPathwayUnitLabel": "When the learner completes",
    "seq.triggerPathwayLoadFailed": "The pathway list could not be loaded.",
    "seq.reviewThresholdHint": "Sent when a client completes {n} sessions.",
    "seq.reviewThresholdLink": "Change the number in Settings",
    "seq.offsetUnit.minutes": "minutes",
    "seq.offsetUnit.hours": "hours",
    "seq.offsetUnit.days": "days",
    "seq.offsetUnitOne.minutes": "minute",
    "seq.offsetUnitOne.hours": "hour",
    "seq.offsetUnitOne.days": "day",
    "seq.offsetAnchor.afterTrigger": "after trigger",
    "seq.offsetAnchor.beforeSession": "before session",
  },
  es: {
    "seq.saveDraft": "Guardar borrador",
    "seq.activate": "Activar",
    "seq.savedDraft": "Borrador guardado",
    "seq.activated": "Secuencia activada",
    "seq.namePlaceholder": "Nombre de la secuencia",
    "seq.triggerLabel": "Desencadenante",
    "seq.triggerLocked": "El desencadenante de una secuencia predefinida no se puede cambiar.",
    "seq.triggerParamDays": "días",
    "seq.triggerParamTag": "etiqueta",
    "seq.triggerParamN": "número de sesión",
    "seq.stepTitle": "Paso {n}",
    "seq.stepSummary": "Paso {n} · {offset} · {excerpt}",
    "seq.stepSummaryNoBody": "Paso {n} · {offset} · sin contenido",
    "seq.sendTestSent": "Prueba enviada a tu propia dirección",
    "seq.sendTestQueued": "Prueba registrada: se enviará en cuanto el envío de correos esté configurado",
    "seq.deleteStep": "Eliminar",
    "seq.deleteStepConfirmTitle": "¿Eliminar este paso?",
    "seq.deleteStepConfirmBody": "Este paso se eliminará de la secuencia.",
    "seq.deleteStepConfirm": "Eliminar paso",
    "seq.subjectLabel": "Asunto",
    "seq.subjectPlaceholder": "Asunto del correo",
    "seq.bodyLabel": "Mensaje",
    "seq.bookAgainButton": "Botón «Reservar de nuevo»",
    "seq.addStep": "+ Añadir paso",
    "seq.unsavedTitle": "¿Salir sin guardar?",
    "seq.unsavedBody": "Los cambios de esta secuencia no se han guardado.",
    "seq.unsavedLeave": "Salir",
    "seq.unsavedStay": "Quedarse",
    "seq.confirmReminder": "Confirmar",
    "seq.rescheduleReminder": "Aplazar",
    "seq.joinReminder": "Unirse",
    "seq.offsetValueLabel": "Plazo",
    "seq.offsetUnitAnchorLabel": "Unidad y momento",
    "seq.system.welcome": "Bienvenida",
    "seq.system.sessionReminders": "Recordatorios de sesión",
    "seq.system.followUp": "Seguimiento",
    "seq.system.reEngagement": "Reactivación",
    "seq.system.reviewRequest": "Solicitud de reseña",
    "seq.trigger.newClient": "Nuevo cliente",
    "seq.trigger.bookingExists": "Reserva existente",
    "seq.trigger.bookingCompleted": "Sesión completada",
    "seq.trigger.purchaseCompleted": "Compra realizada",
    "seq.trigger.noActivity": "Sin actividad desde hace {days} días",
    "seq.trigger.packBalanceHits": "Saldo de bono en {n}",
    "seq.trigger.tagAdded": "Etiqueta «{tag}» añadida",
    "seq.trigger.nthSessionCompleted": "Sesión número {n} completada",
    "seq.trigger.reviewMoment": "Momento de la solicitud de reseña",
    "seq.trigger.reviewMomentAt": "Tras {n} sesiones completadas",
    "seq.trigger.pathwayProgress": "Paso o nivel de itinerario completado",
    "seq.trigger.pathwayCompleted": "Itinerario completado",
    "seq.trigger.pathwayUnit.step": "un paso",
    "seq.trigger.pathwayUnit.level": "un nivel",
    "seq.triggerPathwayLabel": "Itinerario",
    "seq.triggerPathwayAny": "Cualquier itinerario",
    "seq.triggerPathwayUnknown": "Itinerario no encontrado",
    "seq.triggerPathwayUnitLabel": "Cuando el alumno completa",
    "seq.triggerPathwayLoadFailed": "No se pudo cargar la lista de itinerarios.",
    "seq.reviewThresholdHint": "Se envía cuando un cliente completa {n} sesiones.",
    "seq.reviewThresholdLink": "Cambiar el número en Ajustes",
    "seq.offsetUnit.minutes": "minutos",
    "seq.offsetUnit.hours": "horas",
    "seq.offsetUnit.days": "días",
    "seq.offsetUnitOne.minutes": "minuto",
    "seq.offsetUnitOne.hours": "hora",
    "seq.offsetUnitOne.days": "día",
    "seq.offsetAnchor.afterTrigger": "tras el desencadenante",
    "seq.offsetAnchor.beforeSession": "antes de la sesión",
  },
};
